import type { TRuleWithTheme } from '@ackee/fela';

export const officeContainer: TRuleWithTheme = () => ({
    lineHeight: '1.7',
    justifyContent: 'center',
    paddingTop: '2.875rem',
});

export const extendTitle = (() => ({
    fontStyle: 'italic',
    fontWeight: '800',
    margin: 'unset',
    fontSize: '1.5rem',
    marginTop: '0.5rem',
    marginBottom: '-0.25rem',

    color: 'inherit',
})) as TRuleWithTheme;

export const extendAddressText: TRuleWithTheme = () => ({
    color: 'inherit',
});

export const extendLink = () => ({
    textDecoration: 'none',
});

export const titleContainer: TRuleWithTheme = () => ({
    marginBottom: '2.1875rem',
});
